import { z } from 'zod';
export * from './entities';
export * from './sanity';
export * from './components';
export * from './shared';

import { SanityComponentUnion, type SanityComponent } from './components';
import { SanityEntityUnion, type SanityEntity } from './entities';

export const SanityAnySchema = z.union([SanityEntityUnion, SanityComponentUnion]);

export type SanityAny = SanityEntity | SanityComponent;
